import React from 'react';
import { Section } from './ui/Section';
import { Button } from './ui/Button';
import { Check, Users, Video, Calendar } from 'lucide-react';
export function ServicesSection() {
  const services = [{
    title: 'Program 1 la 1',
    subtitle: 'Psihoterapie & Coaching (Metoda 3S)',
    icon: <Users className="w-6 h-6" data-id="element-246" />,
    image: 'https://images.unsplash.com/photo-1573497620053-ea5300f94f21?w=600&h=300&fit=crop&crop=center',
    features: ['Reducem anxietatea și fricile care te controlează', 'Reglăm corpul și sistemul tău emoțional', 'Lucrăm tiparele relaționale', 'Clarificăm direcția și deciziile', 'Reconstruim încrederea în sine'],
    cta: 'Aplică pentru Programul 1 la 1',
    link: 'https://wa.me/40742236028'
  }, {
    title: 'Ateliere online LIVE',
    subtitle: 'Lucru practic pe teme',
    icon: <Video className="w-6 h-6" data-id="element-247" />,
    image: 'https://images.unsplash.com/photo-1552664730-d307ca884978?w=600&h=300&fit=crop&crop=center',
    features: ['Anxietate & atacuri de panică', 'Frici și blocaje în decizii', 'Dependențe emoționale / relații toxice', 'Comunicare și limite', 'Reconectare corp–suflet–Dumnezeu'],
    cta: 'Detalii în curând'
  }, {
    title: 'Cursuri online',
    subtitle: 'Înregistrate',
    icon: <Calendar className="w-6 h-6" data-id="element-248" />,
    image: 'https://images.unsplash.com/photo-1434030216411-0b793f4b4173?w=600&h=300&fit=crop&crop=center',
    features: ['Structură + disciplină mentală', 'Tehnici practice pentru reglare emoțională', 'Instrumente pentru relații și comunicare', 'Reconectare interioară consecventă', 'Acces pe viață la materiale'],
    cta: 'Detalii în curând'
  }];
  return <Section id="servicii" background="default" data-id="element-249">
      <div className="text-center mb-16" data-id="element-250">
        <h2 className="text-3xl md:text-4xl font-bold text-brand-text mb-4" data-id="element-251">
          Modalități de a lucra cu mine
        </h2>
        <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-252">
          Alege formatul care ți se potrivește cel mai bine pentru călătoria ta.
        </p>
      </div>

      <div className="grid lg:grid-cols-3 gap-8" data-id="element-253">
        {services.map((service, index) => <div key={index} className="flex flex-col" data-id="element-254">
            {/* Image above card */}
            <div className="w-full h-48 rounded-t-2xl overflow-hidden" data-id="element-255">
              <img src={service.image} alt={service.title} className="w-full h-full object-cover" data-id="element-256" />
            </div>

            {/* Card with border */}
            <div className="flex flex-col flex-1 bg-white rounded-b-2xl border border-t-0 border-brand-primary/20 p-6 hover:shadow-xl transition-all duration-300" data-id="element-257">
              <div className="mb-6" data-id="element-258">
                <div className="w-12 h-12 rounded-lg bg-brand-bg flex items-center justify-center text-brand-primary mb-4" data-id="element-259">
                  {service.icon}
                </div>
                <h3 className="text-2xl font-bold text-brand-text mb-2" data-id="element-260">
                  {service.title}
                </h3>
                <p className="text-brand-primary font-medium" data-id="element-261">
                  {service.subtitle}
                </p>
              </div>

              <ul className="space-y-4 mb-8 flex-1" data-id="element-262">
                {service.features.map((feature, i) => <li key={i} className="flex items-start text-gray-600 text-sm" data-id="element-263">
                    <Check className="w-5 h-5 text-brand-accent mr-3 flex-shrink-0" data-id="element-264" />
                    <span data-id="element-265">{feature}</span>
                  </li>)}
              </ul>

              {service.link ? <a href={service.link} data-id="element-266">
                  <Button variant="primary" fullWidth className="mt-auto" data-id="element-267">
                    {service.cta}
                  </Button>
                </a> : <Button variant="primary" fullWidth className="mt-auto" data-id="element-268">
                  {service.cta}
                </Button>}
            </div>
          </div>)}
      </div>
    </Section>;
}